export default "<p>dinamicvalues works!</p>\n"